import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./u4.css";
try { if (localStorage.getItem("tpms_noglass") === "1") document.body.classList.add("tm-noglass"); } catch {}
window.tpmsToggleGlass = () => {
  try {
    const on = document.body.classList.toggle("tm-noglass");
    localStorage.setItem("tpms_noglass", on ? "1" : "0");
    return on;
  } catch { return false; }
};
import "./authgate.css";
import "./storage.js";
import "./db.js";
import "./toast.js";
import { initErrorCapture } from "./errorlog.js";
import { SupaAuthProvider } from "./supaAuth.jsx";
import OrgGate from "./OrgGate.jsx";
import { AuthProvider } from "./auth.jsx";
import TopBar from "./TopBar.jsx";
import ProjectManager from "./App.jsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30000, retry: 1, refetchOnWindowFocus: false } } });

initErrorCapture();

class RootBoundary extends React.Component {
  constructor(p) { super(p); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) { try { console.error(err); } catch {} }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", background: "var(--bg, #f5f8ff)", padding: 20, fontFamily: "'Cairo','Tajawal',sans-serif", direction: "rtl", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ maxWidth: 640, width: "100%", background: "color-mix(in srgb, var(--surface, #ffffff) 92%, transparent)", border: "1.5px solid var(--line, #e7c9d2)", boxShadow: "4px 4px 0 color-mix(in srgb, var(--accent, #14b8a6) 35%, transparent)", padding: "26px 28px", backdropFilter: "blur(14px)" }}>
          <h2 style={{ fontSize: 20, fontWeight: "bold", margin: "0 0 4px", color: "var(--text, #1c2340)" }}>حدث خطأ غير متوقع</h2>
          <div style={{ fontSize: 13.5, color: "var(--faint, #6b7280)", marginBottom: 12 }}>An unexpected error occurred</div>
          <div style={{ fontSize: 14, color: "var(--text, #1c2340)", lineHeight: 1.9, marginBottom: 14 }}>نعتذر عن هذا الانقطاع المؤقت في المنصة. جميع البيانات محفوظة بأمان، ويمكن استئناف العمل فور إعادة تحميل الصفحة.<br /><span style={{ color: "var(--faint, #6b7280)" }}>We apologize for the interruption. Your data is safe - please reload the page to continue.</span></div>
          <details style={{ marginBottom: 16 }}>
            <summary style={{ fontSize: 13, fontWeight: 700, color: "var(--faint, #6b7280)", cursor: "pointer" }}>التفاصيل التقنية - Technical details</summary>
            <div style={{ direction: "ltr", textAlign: "left", whiteSpace: "pre-wrap", background: "color-mix(in srgb, #e23d3d 6%, transparent)", color: "#9a1b3a", padding: 12, fontSize: 13, fontFamily: "ui-monospace, monospace", marginTop: 8, maxHeight: 220, overflow: "auto", border: "1px solid color-mix(in srgb, #e23d3d 25%, transparent)" }}>{String(this.state.err?.stack || this.state.err)}</div>
          </details>
          <button onClick={() => location.reload()} style={{ fontFamily: "inherit", fontSize: 14.5, fontWeight: 700, padding: "10px 22px", border: "none", background: "var(--accent, #14b8a6)", color: "#ffffff", cursor: "pointer", boxShadow: "3px 3px 0 color-mix(in srgb, var(--accent, #14b8a6) 30%, transparent)" }}>إعادة التحميل - Reload</button>
        </div>
      </div>
    );
  }
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <RootBoundary>
    <QueryClientProvider client={queryClient}>
    <SupaAuthProvider>
      <OrgGate>
        <AuthProvider>
          <TopBar />
          <ProjectManager />
        </AuthProvider>
      </OrgGate>
    </SupaAuthProvider>
  </QueryClientProvider>
  </RootBoundary>
);
